import React, { useEffect, useState, useCallback, Suspense } from "react";
import Navbar from './Navbar';
import Footer from './Footer';
import { Outlet } from 'react-router-dom'; 
import { useLocation } from 'react-router-dom';
import usePrebid from "./prebid/usePrebid";
import AdUnit from './prebid/AdUnit'; 
import ConsentManager from "./consentManagement/ConsentManager";

const Layout = ({ handleModal }) => {
  const [footerFallback, setFooterFallback] = useState(false);
  const location = useLocation();
  const { adUnitsRegistered, isGDPR, showBanner } = usePrebid();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480); 

  // Handle Footer visibility logic on route change
  useEffect(() => {
    // Hide the footer on route change
    setFooterFallback(false);
    // Set a timer to show the footer after 2 seconds
    const timer = setTimeout(() => {
      setFooterFallback(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, [location.pathname]); 

  // Show the footer 
  const showFooter = footerFallback ;

  // Optimized Ads Component (Prevents Re-renders on Route Change)
  const Ads = useCallback(({ position }) => {
  const isAdPage = location.pathname.includes("checkout") || location.pathname.includes("subscription");

  if (!isAdPage) return null; 

  if (position === "navbar") {
    return adUnitsRegistered && (
      isMobile ? (
        <AdUnit adUnitCode="navbar-mobile" />
      ) : (
        <AdUnit adUnitCode="navbar-ad" />
      )
    );
  }

  if (position === "bottom") {
    return adUnitsRegistered && (
      isMobile ? (
        <AdUnit adUnitCode="mobile-bottom" />
      ) : (
        <AdUnit adUnitCode="banner-bottom" />
      )
    ); 
  }

  return null; 
}, [location.pathname, adUnitsRegistered, isMobile]);


  return (
    <div className="flex flex-col min-h-screen">

    {isGDPR && showBanner && <ConsentManager />}

      <Ads position="navbar" />

      <Navbar handleModal={handleModal} />

      <main className="flex-grow min-h-screen">
        <Suspense>
          <Outlet />
        </Suspense>
      </main>

      <Ads position="bottom" />

      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
